import { createRoot } from 'react-dom/client'
import 'admination-design-system'
import { boot } from './boot'
import { initI18n } from './core/i18n'

// PDF and IndexedDB effects use the normal single-mount lifecycle.
initI18n()
boot(createRoot(document.getElementById('root')!))
